module.exports = __webpack_public_path__ + "static/media/stat.67b46577.png";